import { css } from 'styled-components';
import { normalizeColor } from '../utils';
export var colorStyle = function colorStyle(name, value, theme, required) {
  return css(["", ":", ";"], name, normalizeColor(value, theme, required));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-styles/es6/styles/color.js
// module id = 386
// module chunks = 1